<template>
  <div class="dialog-wrap">
    <el-dialog
      title="客户端添加"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      width="480px"
    >
      <el-form
        class="form"
        :model="dataForm"
        :rules="rules"
        ref="dataForm"
        label-width="110px"
      >
        <el-form-item
          label="客户端名称"
          prop="name"
        >
          <el-input
            v-model="dataForm.name"
            placeholder="请输入客户端名称"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="客户端ID"
          prop="appid"
        >
          <el-input
            v-model="dataForm.appid"
            placeholder="请输入客户端ID"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="客户端密钥"
          prop="secret"
        >
          <el-input
            v-model="dataForm.secret"
            placeholder="请输入客户端密钥"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="关联用户分组"
          prop="user_category_ids"
        >
          <el-select
            v-model="dataForm.user_category_ids"
            placeholder="选择分类"
            multiple
          >
            <el-option
              v-for="(item,index) in $store.state.userCategorys"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="在线状态"
          prop="status"
        >
          <el-switch v-model="dataForm.status"></el-switch>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          type="primary"
          @click="handleSubmit"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { clientCreate } from '@/api/operation'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      dataForm: {},
      rules: {
        name: [{ required: true, message: '请输入客户端名称', trigger: 'blur' }],
        appid: [{ required: true, message: '请输入客户端ID', trigger: 'blur' }],
        secret: [{ required: true, message: '请输入客户端密钥', trigger: 'blur' }],
        /*   user_category_ids: [{ required: true, message: '请选择关联用户分类', trigger: 'change' }], */
      }
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    }
  },
  methods: {
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const params = Object.assign({}, this.dataForm, {
            user_category_ids: this.dataForm.user_category_ids ? this.dataForm.user_category_ids.join(',') : ''
          })
          clientCreate(params).then(res => {
            this.$message.success(`添加成功`)
            this.$refs['dataForm'].resetFields()

            this.$emit('submit')
            this.handleClose()
          }).catch(error => {
            console.log('error: ', error)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      this.$emit('close')
    },
  }
}
</script>

<style lang="less" scoped>
.dialog-wrap {
  .form {
    margin-bottom: -18px;
  }
}
</style>
